import { useMemo } from 'react';

import { useInquiryLabelTranslator } from 'modules/Inquiry/inquiryFieldsTranslations/useInquiryLabelTranslator';

export const useFieldCaption = (name: string) => {
  const translateLabelForField = useInquiryLabelTranslator();
  return useMemo(() => translateLabelForField(name), [name, translateLabelForField]);
};
